<template>
  <div id="app">
    <router-view></router-view>
    <modal-root id="modal-root"></modal-root>
    <nav-bar-root id="nav-bar-root"></nav-bar-root>
  </div>
</template>

<script>
import ModalRoot from './modal/ModalRoot.vue';
import NavBarRoot from './modal/NavBarRoot.vue';

function patchActiveButtonsOnMobile() {
  document.addEventListener('touchstart', () => {}, true);
}

export default {
  name: 'App',
  components: {
    NavBarRoot,
    ModalRoot,
  },
  created() {
    patchActiveButtonsOnMobile();
  },
};
</script>

<style lang="scss">
#app {
  direction: rtl;
  font-family: SimplerPro, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: row;
  justify-content: center;

  #modal-root {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  #nav-bar-root {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
</style>
